module.exports = __webpack_public_path__ + "img/d4653cc.jpg";